import get from 'lodash.get';

export const shouldShowHoldRequest = (item, user) => {
    return (
        !!item &&
        !get(item, 'hasRequestedHoldForBuyer') &&
        !get(item, 'isPriceUponRequest') &&
        !get(item, 'isOnHold') &&
        !get(item, 'isSold') &&
        !get(item, 'attributes.customizable[0].value') &&
        get(user, 'canUseNetPrice') &&
        get(item, 'isFurniture')
    );
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/helpers/holdRequest.es.js